import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import urbanHeatPoster from '../../../Assets/Images/ProjectsImg/Using Building Envelopes as Heat Sink to Manage Urban Heat Island (UHI) In Developing Countries/urbanHeatPoster.jpg'

const Urban_Heat_Island = () => {

    return (
        <div className="mt-5">
            <h4>Using Building Envelopes as Heat Sinks to Manage Urban Heat Island (UHI) in Developing Countries: A Context-Specific Approach</h4>

            <div className="card mt-5">
                <img
                    src={urbanHeatPoster}
                    className="card-img-top"
                    alt="Poster"
                />
            </div>

            <div className="mt-5">
                <p>The training program titled "Using Building Envelopes as Heat Sinks to Manage Urban Heat Island (UHI) in Developing Countries: A Context-Specific Approach" focuses on climate-responsive building design strategies. It explores innovative materials, passive cooling techniques, and policy integration to transform building envelopes into effective heat sinks, tailored to the socio-environmental contexts of developing nations.</p>
                <p>This 3-day offline program addresses the Urban Heat Island (UHI) effect in developing countries by focusing on the role of building envelopes as passive heat sinks. It explores scientific principles of heat transfer, material performance, and innovative design solutions like cool roofs, green infrastructure, and high thermal mass materials. The program emphasizes socio-economic and cultural feasibility, along with the critical role of governance, policies, and assessment tools in enabling sustainable UHI mitigation.</p>
            </div>

            <div>
                <p><strong>Beneficiaries:</strong> Urban managers, ULB officials, professionals (architects, planners, engineers), contractors, researchers, academics, policy makers, and others involved in climate-resilient urban development.</p>

                <p><strong>Aim:</strong> To equip participants with knowledge and context-specific strategies for using building envelopes to mitigate UHI effectively in developing nations.</p>

                <p><strong>Objectives:</strong></p>
                <ul>
                    <li>Analyze UHI causes and impacts</li>
                    <li>Understand building thermal dynamics</li>
                    <li>Evaluate passive cooling techniques</li>
                    <li>Develop policy-aligned implementation frameworks</li>
                </ul>

                <p className='mt-4'><strong>Timeline & Duration:</strong> 3 Days (24 Hours | 2–4 Credits)</p>
                <p className='mt-4'><strong>Mode:</strong> Offline</p>

                {/* <p><strong>Status:</strong> Completed</p> */}
            </div>
        </div>
    );
};

export default Urban_Heat_Island;

